module.exports = __webpack_public_path__ + "img/alam-flora.a1e02312.png";